declare namespace $ {

	type $mol_image__uri_bog_bzrl_app_profile_avatar_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile_avatar['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_open_native__files_bog_bzrl_app_profile_avatar_2 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile_avatar['files_handled'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_bzrl_app_profile_avatar_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile_avatar['accept'] >
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_bzrl_app_profile_avatar_4 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile_avatar['multiple'] >
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	export class $bog_bzrl_app_profile_avatar extends $mol_button_open {
		image_uri( ): string
		Image( ): $mol_image
		files( next?: readonly(File)[] ): readonly(File)[]
		files_handled( next?: ReturnType< $bog_bzrl_app_profile_avatar['files'] > ): ReturnType< $bog_bzrl_app_profile_avatar['files'] >
		accept( ): string
		multiple( ): boolean
		Native( ): $mol_button_open_native
		profile( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=avatar.view.tree.d.ts.map